import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ResourceResponse } from "../../domain/models/resources.model";

export class UserInfo {
  constructor(
    public role?: string,
    public roleId?: number,
    public resourceId?: number,
    public practiceId?: number,
    public disciplineId?: number,
    public fullName?: string,
  ) {}
}

@Injectable({ providedIn: "root" })
export class UserService {
  private userInfo: WritableSignal<UserInfo> = signal(new UserInfo());
    private http = inject(HttpClient);
    apiBaseUrl = environment.apiUrl;

  get profile() {
    return this.userInfo;
  }

  updateProfile(
    role?: string,
    roleId?: number,
    resourceId?: number,
    practiceId?: number,
    disciplineId?: number,
    fullName?: string,
  ) {
    this.userInfo.update((old) => ({
      ...old,
      role,
      roleId,
      resourceId,
      practiceId,
      disciplineId,
      fullName
    }));
  }

  getProjectRole(agreementId: number) {
    return this.http.get<ResourceResponse>(`${this.apiBaseUrl}/sm/agreement/${agreementId}/project-roles`);
  }

  addProjectRole(agreementId:number, setRoleProjectDto: any) {
    return this.http.post(`${this.apiBaseUrl}/sm/agreement/${agreementId}/project-role`, { setRoleProjectDto });
  }
}
